export const SUCCESS_MESSAGE = 'Event tracked successfully';
export const UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
export const MAX_RETRIES_EXCEEDED_MESSAGE = 'Event rejected due to exceeded retry count';
export const OPT_OUT_MESSAGE = 'Event skipped due to optOut config';
export const MISSING_API_KEY_MESSAGE = 'Event rejected due to missing API key';
